export default __webpack_public_path__ + "static/media/manage-team.0291d313.svg";